import React, { createContext, useEffect, useState } from 'react';
import api from '../../utils/axiosConfig';

export const VideoContext = createContext();

export const VideoProvider = ({ children }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await api.get('/api/video');
        setVideos(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error('Videoları yükleme hatası:', err);
        setVideos([]);
      }
    };
    fetchVideos();
  }, []);

  const addVideo = async (newVideo) => {
    try {
      const response = await api.post('/api/video', newVideo);
      setVideos((prevVideos) => [...prevVideos, response.data]);
    } catch (err) {
      console.error('Video ekleme hatası:', err);
      throw err;
    }
  };

  const removeVideo = async (index, id) => {
    try {
      await api.delete('/api/video', { data: { id } });
      setVideos((prevVideos) => prevVideos.filter((_, i) => i !== index));
    } catch (err) {
      console.error('Video silme hatası:', err);
      throw err;
    }
  };

  return (
    <VideoContext.Provider value={{ videos, addVideo, removeVideo, setVideos }}>
      {children}
    </VideoContext.Provider>
  );
};
